import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconGooglePodcastsStyle0 = gravityIconIndividualCss;

const GravityIconGooglePodcasts = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'b895809c726d13bb2dd65b96ce01ee9fba25a7aa', color: this.color, size: this.size }, h("svg", { key: '68b2f63f39d7c4228bf61f0dfdd6049a27c883c6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '3af2c0067b49ace33e503b8569207ec2c2aaa9b7', d: "M11 3a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1ZM7.455 6.182a1 1 0 0 0-1 1v3.568a1 1 0 0 0 1.999 0V7.182a1 1 0 0 0-1-1ZM4 9.455a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1Zm14 0a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1ZM6.455 13.727a1 1 0 1 1 2 0v1.091a1 1 0 1 1-2 0v-1.09Zm7.091-6.545a1 1 0 1 1 2 0v1.09a1 1 0 1 1-2 0v-1.09ZM10 16.91a1 1 0 1 1 2 0V18a1 1 0 1 1-2 0v-1.09Zm4.546-6.637a1 1 0 0 0-1 1v3.545a1 1 0 1 0 2 0v-3.545a1 1 0 0 0-1-1ZM11 7.09a1 1 0 0 1 1 1v5.82a1 1 0 1 1-2 0V8.09a1 1 0 0 1 1-1Z", fill: "currentColor" }))));
    }
};
GravityIconGooglePodcasts.style = GravityIconGooglePodcastsStyle0;

export { GravityIconGooglePodcasts as gravity_icon_google_podcasts };

//# sourceMappingURL=gravity-icon-google-podcasts.entry.js.map